import { createLogger } from './createLogger.js';
import type { EvamLogger } from './types.js';

declare global {
  interface Window {
    evamLogger?: EvamLogger;
  }
}

export const logger: EvamLogger = createLogger();
export { createLogger } from './createLogger.js';
export { SDK_NAME, SDK_VERSION } from './version.js';
